import i18n from 'i18next';

import AtlasSdk from '@atlas/sdk';
import { IToastConfig } from '@atlas/sdk/lib/namespaces/toast/toast.types';

import { baseConfirm, withInfo } from '@case-management/components/src/modal-pro/confirm';

import { TimeoutError, NetworkError } from './error';

export enum ErrorMessageType {
  NOTIFICATION,
  MODAL,
}

export type ModalConfig = Parameters<typeof baseConfirm>[0];

export type NotificationConfig = IToastConfig;

export type RuleModal = Readonly<{ reg: RegExp; type: ErrorMessageType.MODAL; get: () => ModalConfig }>;

export type RuleNotification = Readonly<{
  reg: RegExp;
  type: ErrorMessageType.NOTIFICATION;
  get: () => NotificationConfig;
}>;

export type Rule = RuleModal | RuleNotification;

export const rules: Rule[] = [
  {
    reg: new RegExp(`^(${TimeoutError.CODE})|(${NetworkError.CODE})$`),
    type: ErrorMessageType.NOTIFICATION,
    get: () => ({
      type: AtlasSdk.toast.types.WARNING,
      message: i18n.t('errorCode.timeout', { defaultValue: 'Your internet connection is unstable' }),
    }),
  },
  {
    reg: /^005/,
    type: ErrorMessageType.NOTIFICATION,
    get: () => ({
      type: AtlasSdk.toast.types.DANGER,
      message: i18n.t('errorCode.0050006'),
    }),
  },
  {
    reg: /^1520000$/,
    type: ErrorMessageType.NOTIFICATION,
    get: () => ({
      type: AtlasSdk.toast.types.WARNING,
      title: i18n.t('errorCode.server_error_title'),
      message: i18n.t('errorCode.server_error_message'),
    }),
  },
  {
    reg: /^1523600$/,
    type: ErrorMessageType.NOTIFICATION,
    get: () => ({
      title: i18n.t('common.warning'),
      type: AtlasSdk.toast.types.WARNING,
      message: i18n.t('errorCode.cases_do_not_resolve_by_email_channel'),
    }),
  },
  {
    reg: /^1523017$/,
    type: ErrorMessageType.MODAL,
    get: () =>
      withInfo({
        title: i18n.t('errorCode.cases_update_limit.title'),
        content: i18n.t('errorCode.cases_update_limit.message'),
        okText: i18n.t('errorCode.cases_update_limit.ok'),
      }),
  },
];
